// Meta Pixel helper — safe no-op if fbq isn't loaded (e.g. dev, adblock, SSR).
// Pixel base snippet lives in /public/index.html and installs `window.fbq`.
// Docs: https://developers.facebook.com/docs/meta-pixel/reference

const isBrowser = typeof window !== "undefined";

// Fire a standard Meta event (PageView, Lead, InitiateCheckout, Subscribe, Purchase, StartTrial…).
// `params` is optional; Meta uses `value`, `currency`, `content_name`, `predicted_ltv`, etc.
// `eventId` must match the server's Conversions API event_id so Meta counts it once.
export const fbTrack = (event, params, eventId) => {
  if (!isBrowser || typeof window.fbq !== "function") return;
  try {
    if (eventId) window.fbq("track", event, params || {}, { eventID: eventId });
    else if (params) window.fbq("track", event, params);
    else window.fbq("track", event);
  } catch {
    // never let analytics break the app
  }
};

const readCookie = (name) =>
  document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=").slice(1).join("=");

// Pixel cookies + page, sent to the backend so its server-side copy matches this browser.
export const metaCtx = () => {
  if (!isBrowser) return {};
  return { fbp: readCookie("_fbp"), fbc: readCookie("_fbc"), url: window.location.href };
};

// Custom (non-standard) event helper, in case we ever need one.
export const fbTrackCustom = (event, params) => {
  if (!isBrowser || typeof window.fbq !== "function") return;
  try {
    if (params) window.fbq("trackCustom", event, params);
    else window.fbq("trackCustom", event);
  } catch {}
};
